import Temperature from "./Temperature";

export default class DewPoint extends Temperature {
  static getLabel() {
    return "Dew Point";
  }
}
